import "core-js/modules/es6.string.small";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDocumentsById } from '~/services/editorial';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import GlobalArticleCard from '~/components/molecules/Editorial/Global/GlobalArticleCard.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

export default {
  name: 'ArticleList',
  components: {
    GlobalTitle: GlobalTitle,
    SimpleParagraph: SimpleParagraph,
    GlobalArticleCard: GlobalArticleCard
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      currentArticles: this.payload.items.map(function (_ref5) {
        var article = _ref5.article;
        return {
          slug: article.slug,
          image: {
            small: '',
            medium: '',
            large: ''
          },
          tags: article.tags,
          date: '',
          title: '',
          description: [],
          readingTime: 0,
          difficulty: 0
        };
      })
    };
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4;

      return {
        title: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.title) != null ? _ref4[0] : _ref4 : _ref4 : _ref4) || {},
        subtitle: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? (_ref3 = _ref3.subtitle) != null ? _ref3[0] : _ref3 : _ref3 : _ref3) || {},
        paragraph: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.paragraph : _ref2 : _ref2) || [],
        readMore: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.read_more : _ref : _ref) === 'Yes'
      };
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var ids, _ref7, results;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ids = this.payload.items.map(function (_ref6) {
                var article = _ref6.article;
                return article.id;
              });
              _context.next = 3;
              return fetchDocumentsById(this.$store, ids);

            case 3:
              _ref7 = _context.sent;
              results = _ref7.results;
              this.currentArticles = results.map(function (_ref8) {
                var article = _ref8.data,
                    tags = _ref8.tags;
                return {
                  tags: tags,
                  slug: article.slug,
                  image: {
                    small: formatPrismicImage(article.image.small.url) || EMPTY_PIXEL,
                    medium: formatPrismicImage(article.image.medium.url) || EMPTY_PIXEL,
                    large: formatPrismicImage(article.image.large.url) || EMPTY_PIXEL
                  },
                  date: article.date,
                  title: article.main_title[0].text || '',
                  description: article.description,
                  readingTime: article.reading_time || 0,
                  difficulty: article.difficulty || 0
                };
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }()
};